export default __webpack_public_path__ + "static/tool-store-c810cf0e511660209c5d85a16cb12ff1.jpg";